import { Record } from 'immutable';
export default class SecurityPhoneNumber extends Record({
  id: null,
  info: null,
  setupTime: null,
  confirmedTime: null
}) {}